/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Typewriter_Project_NoteInputs */

const en_typewriter_project_note = /** @type {(inputs: Typewriter_Project_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Love to work in interesting projects`)
};

const ar_typewriter_project_note = /** @type {(inputs: Typewriter_Project_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أحب العمل على مشاريع مثيرة للاهتمام`)
};

const bn_typewriter_project_note = /** @type {(inputs: Typewriter_Project_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আকর্ষণীয় প্রজেক্টে কাজ করতে ভালোবাসি`)
};

const de_typewriter_project_note = /** @type {(inputs: Typewriter_Project_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich arbeite gerne an interessanten Projekten`)
};

const es_typewriter_project_note = /** @type {(inputs: Typewriter_Project_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Me encanta trabajar en proyectos interesantes.`)
};

const fr_typewriter_project_note = /** @type {(inputs: Typewriter_Project_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aime travailler sur des projets intéressants`)
};

const pt_typewriter_project_note = /** @type {(inputs: Typewriter_Project_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adoro trabalhar em projetos interessantes`)
};

const zh_typewriter_project_note = /** @type {(inputs: Typewriter_Project_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`喜欢从事有趣的项目`)
};

const tr_typewriter_project_note = /** @type {(inputs: Typewriter_Project_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İlginç projelerde çalışmayı seviyorum`)
};

const ru_typewriter_project_note = /** @type {(inputs: Typewriter_Project_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Люблю работать в интересных проектах`)
};

const pl_typewriter_project_note = /** @type {(inputs: Typewriter_Project_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uwielbiam pracować przy ciekawych projektach`)
};

/**
* | output |
* | --- |
* | "Love to work in interesting projects" |
*
* @param {Typewriter_Project_NoteInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const typewriter_project_note = /** @type {((inputs?: Typewriter_Project_NoteInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Typewriter_Project_NoteInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_typewriter_project_note(inputs)
	if (locale === "bn") return bn_typewriter_project_note(inputs)
	if (locale === "de") return de_typewriter_project_note(inputs)
	if (locale === "es") return es_typewriter_project_note(inputs)
	if (locale === "fr") return fr_typewriter_project_note(inputs)
	if (locale === "pt") return pt_typewriter_project_note(inputs)
	if (locale === "zh") return zh_typewriter_project_note(inputs)
	if (locale === "tr") return tr_typewriter_project_note(inputs)
	if (locale === "ru") return ru_typewriter_project_note(inputs)
	if (locale === "pl") return pl_typewriter_project_note(inputs)
	return en_typewriter_project_note(inputs)
});